import { cn } from '../../utils.js';

/**
 * On/off switch. Direction-agnostic: the knob is positioned with
 * `inset-inline-start`, so "on" is toward the end of the line in both LTR and RTL.
 */
export function Switch({
  checked,
  onChange,
  disabled,
  'aria-label': ariaLabel,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  'aria-label': string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-emerald-600' : 'bg-muted-foreground/30',
        className,
      )}
    >
      <span
        className="absolute h-4 w-4 rounded-full bg-white shadow transition-[inset-inline-start] duration-200"
        style={{ insetInlineStart: checked ? '1.125rem' : '0.125rem' }}
      />
    </button>
  );
}
